// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4acd9459","732":"ff1cc765","977":"36a79312"}[chunkId] + ".chunk.js";
};